export class DeviceParamGatewayV3Network {
    public type: string = "";
    public get_ip: string = "";
    public iface: string = "";
    public ip: string = "";
    public netmask: string = "";
    public gw: string = "";
    public dns: string = "";
    public ssid: string = "";
    public security: string = "";
    public psk: string = "";
    public pincode: string = "";
}
